import { render, staticRenderFns } from "./BGuide.vue?vue&type=template&id=8ee0fb5e"
import script from "./BGuide.vue?vue&type=script&lang=js"
export * from "./BGuide.vue?vue&type=script&lang=js"
import style0 from "./BGuide.vue?vue&type=style&index=0&id=8ee0fb5e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports